/**
 * グルーピング選択用VOクラス
 *
 * @export GroupingDataModel
 * @class GroupingDataModel
 */
export class GroupingDataModel {
  /** 受注コード */
  public GroupingCode = String('');
  /** シェル種別 */
  public GroupingName = String('');
  /** 取扱生協（いばらき）*/
  public EnableCoop142 = String('0');
  /** 取扱生協（とちぎ）*/
  public EnableCoop163 = String('0');
  /** 取扱生協（ぐんま）*/
  public EnableCoop185 = String('0');
  /** 取扱生協（ちば）*/
  public EnableCoop240 = String('0');
  /** 取扱生協（さいたま）*/
  public EnableCoop210 = String('0');
  /** 取扱生協（とうきょう）*/
  public EnableCoop302 = String('0');
  /** 取扱生協（ながの）*/
  public EnableCoop515 = String('0');
  /** 取扱生協（にいがた）*/
  public EnableCoop451 = String('0');
}
